import axios from 'axios';
import { MarketId } from 'types/market-id.enum';
import { FishGroupSpecies } from '../types/fish-group-species.type';

// GET
// /ewosapi/v1/planandprognosis/species/market/{marketId}
export const getFishGroupSpecies = async (marketId: MarketId): Promise<FishGroupSpecies[]> => {
  const res = await axios.get<FishGroupSpecies[]>(`/ewosapi/v1/planandprognosis/species/market/${marketId}`);
  return res.data;
};
